import { FC, ReactNode, useCallback, useMemo, useReducer, useRef } from "react";
import { createBorrowerProfilingAsyncActions, createBorrowerProfilingSyncActions } from "./actions";
import { MainBorrowerProfilingContext } from "./MainBorrowerProfilingContext";
import { initialState, mainBorrowerProfilingReducer } from "./reducer";

export const MainBorrowerProfilingProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(mainBorrowerProfilingReducer, initialState)

  const stateRef = useRef(state)
  stateRef.current = state
  const getState = useCallback(() => stateRef.current, [])

  const syncActions = useMemo(() => createBorrowerProfilingSyncActions(dispatch), [])
  const asyncActions = useMemo(() => createBorrowerProfilingAsyncActions(syncActions, getState), [syncActions, getState])

  const value = useMemo(() => ({
    state,
    dispatch,
    ...syncActions,
    ...asyncActions
  }), [state, dispatch, syncActions, asyncActions])

  return <MainBorrowerProfilingContext.Provider value={value}>
    {children}
  </MainBorrowerProfilingContext.Provider>
}

